import { render } from "./PieChartDonut.vue?vue&type=template&id=1cb67b1a"
import script from "./PieChartDonut.vue?vue&type=script&lang=js"
export * from "./PieChartDonut.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__